// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__UGVn3","item":"footer_item__5DgIE","img":"footer_img__Mq+9k","text":"footer_text__UGg5m"};